import React, { Fragment } from "react";
import { NavLink } from "react-router-dom";
import { ListGroup, ListGroupItem } from 'reactstrap';

import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';

import TicketLabel from "./TicketLabel";
import TicketBadge from "./TicketBadge";
import CustomerBadge from "./CustomerBadge";
import MyDateRenderer from "./MyDateRenderer";
import ConfirmModal from "./ConfirmModal";

import { useDispatch, useSelector } from "react-redux";
import * as kanbanActions from "../actions/KanbanActions";

const KanbanList = (props) => {
    const dispatch = useDispatch();

    const user = useSelector((state) => state.login.user);

    const [selectedId, setSelectedId] = React.useState(0);
    const [selectedIndex, setSelectedIndex] = React.useState(-1);
    const [selectedUserId, setSelectedUserId] = React.useState(-1);
    const [showAssignMeModal, setShowAssignMeModal] = React.useState(false);
    const [showAssignModal, setShowAssignModal] = React.useState(false);

    const getInvoiceNumberDisplay = (item) => {
        var value = "";

        if(item.regionShortCode && item.regionShortCode.length > 0) {
            value += item.regionShortCode;
        }

        if(item.crmInvoiceNumber && item.crmInvoiceNumber.length > 0) {
            if(value.length > 0) {
                value += " | ";
            }
            
            value += item.crmInvoiceNumber;
        }

        if(item.taxInvoiceNumber && item.taxInvoiceNumber.length > 0) {
            if(value.length > 0) {
                value += " | ";
            }
            
            value += item.taxInvoiceNumber;
        }

        if(item.sasoRequestNumber && item.sasoRequestNumber.length > 0) {
            if(value.length > 0) {
                value += " | ";
            }
            
            value += item.sasoRequestNumber;
        }

        if(item.fasehRequestNumber && item.fasehRequestNumber.length > 0) {
            if(value.length > 0) {
                value += " | ";
            }
            
            value += item.fasehRequestNumber;
        }

        return value;
    }

    const getTechnicalUserList = (groupId) => {
        var arrGroupList = [];

        props.groupUserList.forEach((groupUser, i) => {
            if(groupUser.groupId == groupId && groupUser.isTechnicalUser === true) {
                arrGroupList.push(groupUser);
            }
        });

        return arrGroupList;
    }

    const isTechnicalUser = (groupId, userId) => {
        var valid = false;

        props.groupUserList.forEach((groupUser, i) => {
            if(groupUser.groupId == groupId && groupUser.isTechnicalUser === true && groupUser.userId === userId) {
                valid = true;
            }
        });

        return valid;
    }

    const isManagerUser = (groupId, userId) => {
        var valid = false;

        props.groupUserList.forEach((groupUser, i) => {
            if(groupUser.groupId == groupId && (groupUser.userType === "Manager" || groupUser.userType === "Group Leader") && groupUser.userId === userId) {
                valid = true;
            }
        });

        return valid;
    }

    const isDecisionMaker = (groupId, userId) => {
        var valid = false;

        props.groupUserList.forEach((groupUser, i) => {
            if(groupUser.groupId == groupId && groupUser.isDecisionMaker === true && groupUser.userId === userId) {
                valid = true;
            }
        });

        return valid;
    }

    const isDecisionMakerExternal = (groupId, userId) => {
        var valid = false;

        props.groupUserList.forEach((groupUser, i) => {
            if(groupUser.groupId == groupId && groupUser.isDecisionMakerExternal === true && groupUser.userId === userId) {
                valid = true;
            }
        });

        return valid;
    }

    const getPDUserList = (pdGroupId) => {
        var arrGroupList = [];

        props.pdGroupUserList.forEach((pdGroupUser, i) => {
            if(pdGroupUser.groupId == pdGroupId) {
                arrGroupList.push(pdGroupUser);
            }
        });

        return arrGroupList;
    }

    const isPDUser = (pdGroupId, pdUserId) => {
        var valid = false;

        props.pdGroupUserList.forEach((pdGroupUser, i) => {
            if(pdGroupUser.groupId == pdGroupId && pdGroupUser.userId === pdUserId) {
                valid = true;
            }
        });

        return valid;
    }

    const isPDManagerUser = (pdGroupId, pdUserId) => {
        var valid = false;

        props.pdGroupUserList.forEach((pdGroupUser, i) => {
            if(pdGroupUser.groupId == pdGroupId && (pdGroupUser.userType === "Manager" || pdGroupUser.userType === "Group Leader") && pdGroupUser.userId === pdUserId) {
                valid = true;
            }
        });

        return valid;
    }

    const getInspectorCoordinatorUserList = () => {
        var arrUserList = [];

        props.inspectionCoordinatorList.forEach((inspectionCoordinatorUser, i) => {
            arrUserList.push(inspectionCoordinatorUser);
        });

        return arrUserList;
    }

    const canAssignTicketToMe = (status, item) => {
        if(item.serviceId === 4) {
            if(status === "New") {
                return user && user.canAssignMePd && !user.canAssignAny && !item.pdGroupUserName && isPDUser(item.pdGroupId, user.id);
            }
            else if(status === "Final Decision") {
                return user && user.canAssignMePd && !item.decisionUserName && isPDUser(item.pdGroupId, user.id);
            }
        }
        else if(item.serviceId === 6) {
            if(status === "Pending for Inspection") {
                return user && user.canAssignMeInspection && !user.canAssignInspection && !item.inspectionCoordinatorUserName;
            }
        }
        else if(item.serviceId === 7) {
            if(status === "Pending for Sampling") {
                return user && user.canAssignMeSampling && !item.samplingUserName;
            }
        }
        else {
            if(status === "New" || status === "Phase 1 Evaluation" || status === "Phase 2 Evaluation") {
                return user && user.canAssignMe && !user.canAssignAny && !item.groupUserName && isTechnicalUser(item.groupId, user.id);
            }
            else if(status === "In Progress") {
                if(item.serviceId === 5 || item.serviceId === 8 || item.serviceId === 9 || item.serviceId === 10) {
                    return user && user.canAssignMe && !user.canAssignAny && !item.groupUserName && isTechnicalUser(item.groupId, user.id);
                }
            }
            else if(status === "Data Review") {
                return user && (user.isDataProcessing || (!item.groupUserName && isTechnicalUser(item.groupId, user.id))) && !user.canAssignAny && !item.dataReviewUserName;
            }
            else if(status === "Ready To Issue") {
                return user && user.isDataProcessing && !user.canAssignAny && !item.dataReviewUserName;
            }
            else if(status === "PD Review" || status === "Technical Review" || status === "Technical Support") {
                return user && user.canAssignMePd && !user.canAssignAny && !item.pdGroupUserName && isPDUser(item.pdGroupId, user.id);
            }
            else if(status === "Final Decision") {
                if(item.isDecisionMakerExternal) {
                    return user && user.canAssignMeDecisionMaker && !item.decisionUserName && isDecisionMakerExternal(item.groupId, user.id);
                }
                else {
                    return user && user.canAssignMeDecisionMaker && !item.decisionUserName && isDecisionMaker(item.groupId, user.id);
                }
            }
        }

        return false;
    }

    const canAssignTicketToAnyone = (status, item) => {
        if(item.serviceId === 4) {
            if(status === "New") {
                return user && user.canAssignAny && isPDManagerUser(item.pdGroupId, user.id) && !item.pdGroupUserName;
            }
        }
        else {
            if(status === "New" || status === "Phase 1 Evaluation" || status === "Phase 2 Evaluation") {
                return user && user.canAssignAny && isManagerUser(item.groupId, user.id) && !item.groupUserName;
            }
            else if(status === "In Progress") {
                if(item.serviceId === 5 || item.serviceId === 8 || item.serviceId === 9 || item.serviceId === 10) {
                    return user && user.canAssignAny && isManagerUser(item.groupId, user.id) && !item.groupUserName;
                }
            }
            else if(status === "Pending for Inspection") {
                return user && user.canAssignInspection && !item.inspectionCoordinatorUserName;
            }
        }

        return false;
    }

    const onCloseModalClick = () => {
        setSelectedId(0);
        setSelectedIndex(-1);
        setSelectedUserId(-1);
        setShowAssignMeModal(false);
        setShowAssignModal(false);
    }

    const assignMeTicket = (id, index) => {
        setSelectedId(id);
        setSelectedIndex(index);
        setSelectedUserId(user.id);
        setShowAssignMeModal(true);
    }

    const onAssignMeTicket = async () => {
        if(selectedId > 0 && selectedIndex >= 0 && selectedUserId > 0) {
            dispatch(kanbanActions.assignTicket(selectedId, selectedUserId, true, props.list, selectedIndex));
        }

        onCloseModalClick();
    }

    const assignTicket = (id, index, userId) => {
        setSelectedId(id);
        setSelectedIndex(index);
        setSelectedUserId(userId);
        setShowAssignModal(true);
    }

    const onAssignTicket = async () => {
        if(selectedId > 0 && selectedIndex >= 0 && selectedUserId > 0) {
            dispatch(kanbanActions.assignTicket(selectedId, selectedUserId, false, props.list, selectedIndex));
        }

        onCloseModalClick();
    }

    return (
        <div className="tasks-list">
            <div className="d-flex mb-2">
                <div className="flex-grow-1">
                    <h6 className="fs-14 text-uppercase fw-semibold mb-0">{props.title} <small className={`badge ${props.titleClass} align-bottom ms-1 totaltask-badge`}>{props.list ? props.list.length : 0}</small></h6>
                </div>
            </div>
            <SimpleBar className="tasks-wrapper px-3 mx-n3" forceVisible={true} autoHide={false}>
                <div className="tasks">
                    {props.list && props.list.map(function(item, index){
                        return(
                            <div className={`card tasks-box ${item.ticketType === "CONTAINER" ? ["card-light", "border", "border-1", props.borderClass].join(" ") : ""}`} key={index}>
                                <div className="card-body">
                                    <div className="d-flex">
                                        <h6 className="fs-15 mb-0 flex-grow-1 text-truncate task-title">
                                            <NavLink to={`/request-edit/${item.id}`} className="text-body d-block">
                                                <TicketLabel item={item} />
                                            </NavLink>
                                            <TicketBadge item={item} />
                                        </h6>
                                        {/* <div className="dropdown">
                                            <a href="#" className="text-muted" id="dropdownMenuLink1" data-bs-toggle="dropdown" aria-expanded="false"><i className="ri-more-fill"></i></a>
                                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                                                <li><a className="dropdown-item" href="apps-tasks-details.html"><i className="ri-eye-fill align-bottom me-2 text-muted"></i> View</a></li>
                                                <li><a className="dropdown-item" href="#"><i className="ri-edit-2-line align-bottom me-2 text-muted"></i> Edit</a></li>
                                                <li><a className="dropdown-item" data-bs-toggle="modal" href="#deleteRecordModal"><i className="ri-delete-bin-5-line align-bottom me-2 text-muted"></i> Delete</a></li>
                                            </ul>
                                        </div> */}
                                    </div>
                                    {(item.tagData || item.otherTagData) &&
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1 text-truncate text-muted fs-11" title={item.tagData}>
                                            {item.tagData}
                                        </div>
                                        <div className="flex-shrink-0">
                                            {item.otherTagData &&
                                            <i className="ri-information-line align-bottom text-warning" title={item.otherTagData}></i>
                                            }
                                        </div>
                                    </div>
                                    }
                                    {item.customerName &&
                                    <p className="mb-0 fs-11 flex-grow-1 text-truncate text-dark" style={{marginBottom:0}}>
                                        <CustomerBadge item={item} />
                                    </p>
                                    }
                                    <p className="fs-11 flex-grow-1 text-truncate text-muted">
                                        {getInvoiceNumberDisplay(item)}
                                    </p>
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <span className="badge" style={{backgroundColor: item.serviceColorCode}}>{item.serviceName}</span>
                                            {item.certificateCategory && <Fragment><br /><span className="badge bg-danger">{item.certificateCategory}</span></Fragment>}
                                            {item.factoryAuditCategory && <Fragment><br /><span className="badge bg-danger">{item.factoryAuditCategory}</span></Fragment>}
                                        </div>
                                        <div className="flex-shrink-0">
                                            <div style={{textAlign: "right"}}>
                                                {props.title === "New" && canAssignTicketToMe("New", item) &&
                                                    <button type="button" className="btn btn-primary btn-icon rounded-pill ms-1" title="Assign Me"
                                                        onClick={() => assignMeTicket(item.id, index)}
                                                    >
                                                        <i className="ri-user-follow-line" />
                                                    </button>
                                                }

                                                {props.title === "In Progress" && canAssignTicketToMe("In Progress", item) &&
                                                    <button type="button" className="btn btn-primary btn-icon rounded-pill ms-1" title="Assign Me"
                                                        onClick={() => assignMeTicket(item.id, index)}
                                                    >
                                                        <i className="ri-user-follow-line" />
                                                    </button>
                                                }

                                                {props.title === "Data Review" && canAssignTicketToMe("Data Review", item) &&
                                                    <button type="button" className="btn btn-primary btn-icon rounded-pill ms-1" title="Assign Me"
                                                        onClick={() => assignMeTicket(item.id, index)}
                                                    >
                                                        <i className="ri-user-follow-line" />
                                                    </button>
                                                }

                                                {props.title === "Phase 1 Evaluation" && canAssignTicketToMe("Phase 1 Evaluation", item) &&
                                                    <button type="button" className="btn btn-primary btn-icon rounded-pill ms-1" title="Assign Me"
                                                        onClick={() => assignMeTicket(item.id, index)}
                                                    >
                                                        <i className="ri-user-follow-line" />
                                                    </button>
                                                }

                                                {props.title === "Phase 2 Evaluation" && canAssignTicketToMe("Phase 2 Evaluation", item) &&
                                                    <button type="button" className="btn btn-primary btn-icon rounded-pill ms-1" title="Assign Me"
                                                        onClick={() => assignMeTicket(item.id, index)}
                                                    >
                                                        <i className="ri-user-follow-line" />
                                                    </button>
                                                }

                                                {props.title === "Pending for Inspection" && canAssignTicketToMe("Pending for Inspection", item) &&
                                                    <button type="button" className="btn btn-primary btn-icon rounded-pill ms-1" title="Assign Me"
                                                        onClick={() => assignMeTicket(item.id, index)}
                                                    >
                                                        <i className="ri-user-follow-line" />
                                                    </button>
                                                }

                                                {props.title === "Pending for Sampling" && canAssignTicketToMe("Pending for Sampling", item) &&
                                                    <button type="button" className="btn btn-primary btn-icon rounded-pill ms-1" title="Assign Me"
                                                        onClick={() => assignMeTicket(item.id, index)}
                                                    >
                                                        <i className="ri-user-follow-line" />
                                                    </button>
                                                }

                                                {props.title === "PD Review" && canAssignTicketToMe("PD Review", item) &&
                                                    <button type="button" className="btn btn-primary btn-icon rounded-pill ms-1" title="Assign Me"
                                                        onClick={() => assignMeTicket(item.id, index)}
                                                    >
                                                        <i className="ri-user-follow-line" />
                                                    </button>
                                                }

                                                {props.title === "Technical Review" && canAssignTicketToMe("Technical Review", item) &&
                                                    <button type="button" className="btn btn-primary btn-icon rounded-pill ms-1" title="Assign Me"
                                                        onClick={() => assignMeTicket(item.id, index)}
                                                    >
                                                        <i className="ri-user-follow-line" />
                                                    </button>
                                                }

                                                {props.title === "Technical Support" && canAssignTicketToMe("Technical Support", item) &&
                                                    <button type="button" className="btn btn-primary btn-icon rounded-pill ms-1" title="Assign Me"
                                                        onClick={() => assignMeTicket(item.id, index)}
                                                    >
                                                        <i className="ri-user-follow-line" />
                                                    </button>
                                                }

                                                {props.title === "Final Decision" && canAssignTicketToMe("Final Decision", item) &&
                                                    <button type="button" className="btn btn-primary btn-icon rounded-pill ms-1" title="Assign Me"
                                                        onClick={() => assignMeTicket(item.id, index)}
                                                    >
                                                        <i className="ri-user-follow-line" />
                                                    </button>
                                                }

                                                {props.title === "Ready To Issue" && canAssignTicketToMe("Ready To Issue", item) &&
                                                    <button type="button" className="btn btn-primary btn-icon rounded-pill ms-1" title="Assign Me"
                                                        onClick={() => assignMeTicket(item.id, index)}
                                                    >
                                                        <i className="ri-user-follow-line" />
                                                    </button>
                                                }

                                                {props.title === "New" && canAssignTicketToAnyone("New", item) &&
                                                    <select className="form-select-sm" style={{width:150}}
                                                        value={index === selectedIndex ? selectedUserId : ""}
                                                        onChange={e => assignTicket(item.id, index, e.target.value)}
                                                    >
                                                        <option value={0}>...</option>
                                                        {item.serviceId !== 4 &&
                                                        getTechnicalUserList(item.groupId).map(function(item, index){
                                                            return (
                                                                <option key={index} value={item.userId}>{item.fullName}</option>
                                                            );
                                                        })
                                                        }
                                                        {item.serviceId === 4 &&
                                                        getPDUserList(item.pdGroupId).map(function(item, index){
                                                            return (
                                                                <option key={index} value={item.userId}>{item.fullName}</option>
                                                            );
                                                        })
                                                        }
                                                    </select>
                                                }

                                                {props.title === "In Progress" && canAssignTicketToAnyone("In Progress", item) &&
                                                    <select className="form-select-sm" style={{width:150}}
                                                        value={index === selectedIndex ? selectedUserId : ""}
                                                        onChange={e => assignTicket(item.id, index, e.target.value)}
                                                    >
                                                        <option value={0}>...</option>
                                                        {getTechnicalUserList(item.groupId).map(function(item, index){
                                                            return (
                                                                <option key={index} value={item.userId}>{item.fullName}</option>
                                                            );
                                                        })}
                                                    </select>
                                                }

                                                {props.title === "Phase 1 Evaluation" && canAssignTicketToAnyone("Phase 1 Evaluation", item) &&
                                                    <select className="form-select-sm" style={{width:150}}
                                                        value={index === selectedIndex ? selectedUserId : ""}
                                                        onChange={e => assignTicket(item.id, index, e.target.value)}
                                                    >
                                                        <option value={0}>...</option>
                                                        {getTechnicalUserList(item.groupId).map(function(item, index){
                                                            return (
                                                                <option key={index} value={item.userId}>{item.fullName}</option>
                                                            );
                                                        })}
                                                    </select>
                                                }

                                                {props.title === "Phase 2 Evaluation" && canAssignTicketToAnyone("Phase 2 Evaluation", item) &&
                                                    <select className="form-select-sm" style={{width:150}}
                                                        value={index === selectedIndex ? selectedUserId : ""}
                                                        onChange={e => assignTicket(item.id, index, e.target.value)}
                                                    >
                                                        <option value={0}>...</option>
                                                        {getTechnicalUserList(item.groupId).map(function(item, index){
                                                            return (
                                                                <option key={index} value={item.userId}>{item.fullName}</option>
                                                            );
                                                        })}
                                                    </select>
                                                }

                                                {props.title === "Pending for Inspection" && canAssignTicketToAnyone("Pending for Inspection", item) &&
                                                    <select className="form-select-sm" style={{width:150}}
                                                        value={index === selectedIndex ? selectedUserId : ""}
                                                        onChange={e => assignTicket(item.id, index, e.target.value)}
                                                    >
                                                        <option value={0}>...</option>
                                                        {getInspectorCoordinatorUserList().map(function(item, index){
                                                            return (
                                                                <option key={index} value={item.id}>{item.fullName}</option>
                                                            );
                                                        })}
                                                    </select>
                                                }
                                            </div>
                                            <div>
                                                <span className="badge bg-success">{item.groupUserName}</span>
                                            </div>
                                            <div>
                                                <span className="badge bg-success">{item.decisionUserName}</span>
                                            </div>
                                            <div>
                                                <span className="badge bg-success">{item.pdGroupUserName}</span>
                                            </div>
                                            <div>
                                                <span className="badge bg-success">{item.dataReviewUserName}</span>
                                            </div>
                                            <div>
                                                <span className="badge bg-success">{item.inspectionCoordinatorUserName}</span>
                                            </div>
                                            <div>
                                                <span className="badge bg-success">{item.samplingUserName}</span>
                                            </div>
                                        </div>
                                    </div>
                                    {item.ticketType === "CONTAINER" && 
                                    <div className="mt-3">
                                        <ListGroup>
                                            {item.draftCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Draft <span className="badge bg-success">{item.draftCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.newCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                New <span className="badge bg-success">{item.newCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.inProgressCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                In Progress <span className="badge bg-success">{item.inProgressCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.salesActionCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Sales Action <span className="badge bg-success">{item.salesActionCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.pdReviewCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                PD Review <span className="badge bg-success">{item.pdReviewCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.technicalReviewCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Technical Review <span className="badge bg-success">{item.technicalReviewCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.technicalSupportCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Technical Support <span className="badge bg-success">{item.technicalSupportCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.pendingForSamplingCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Pending for Sampling <span className="badge bg-success">{item.pendingForSamplingCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.samplingInProcessCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Sampling In Process <span className="badge bg-success">{item.samplingInProcessCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.scheduledCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Scheduled <span className="badge bg-success">{item.scheduledCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.waitingCorrectiveActionCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Waiting Corrective Action <span className="badge bg-success">{item.waitingCorrectiveActionCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.dataReviewCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Data Review <span className="badge bg-success">{item.dataReviewCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.phase1EvaluationCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Phase 1 Evaluation <span className="badge bg-success">{item.phase1EvaluationCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.pendingForInspectionCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Pending for Inspection <span className="badge bg-success">{item.pendingForInspectionCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.inspectionInProcessCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Inspection In Process <span className="badge bg-success">{item.inspectionInProcessCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.nonConformityCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Non Conformity <span className="badge bg-success">{item.nonConformityCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.phase2EvaluationCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Phase 2 Evaluation <span className="badge bg-success">{item.phase2EvaluationCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.finalDecisionCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Final Decision <span className="badge bg-success">{item.finalDecisionCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.completedCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Completed <span className="badge bg-success">{item.completedCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.closedCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Closed <span className="badge bg-success">{item.closedCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.cancelledCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Cancelled <span className="badge bg-success">{item.cancelledCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.stoppedCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Stopped <span className="badge bg-success">{item.stoppedCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.abortedCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Aborted <span className="badge bg-success">{item.abortedCount}</span>
                                            </ListGroupItem>
                                            }
                                        </ListGroup>
                                    </div>
                                    }
                                </div>
                                <div className="card-footer border-top-dashed" style={{paddingTop:5, paddingBottom:5}}>
                                    <div className="d-flex">
                                        <div className="flex-grow-1">
                                            <ul className="link-inline mb-0" style={{paddingLeft:0}}>
                                                <li className="list-inline-item">
                                                    <i className="ri-user-add-line align-bottom"></i> {item.addedBy} | <MyDateRenderer value={item.dateAdded} format="mm/dd/yy" />
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="flex-shrink-0">
                                            <ul className="link-inline mb-0">
                                                {/* <li className="list-inline-item">
                                                    <i className="ri-eye-line align-bottom"></i> 04
                                                </li> */}
                                                <li className="list-inline-item">
                                                    <i className="ri-question-answer-line align-bottom"></i> {item.commentCount}
                                                </li>
                                                <li className="list-inline-item">
                                                    <i className="ri-attachment-2 align-bottom"></i> {item.documentCount}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="progress progress-sm bg-soft-success">
                                    <div className={`progress-bar ${props.titleClass}`} style={{width: "100%"}} aria-valuenow="55" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
                        );
                    })}

                    {props.list && props.list.length === 0 &&
                    <div className="">
                        <div className="">
                            <div className="d-flex mb-2">
                                <h6 className="fs-15 mb-0 flex-grow-1 text-truncate task-title"><div className="text-body d-block">No {props.title} Tickets</div></h6>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </SimpleBar>

            <ConfirmModal message={"Are you sure you want to Assign the Ticket?"} show={showAssignMeModal} onCloseClick={onCloseModalClick} onYesClick={onAssignMeTicket} />
            <ConfirmModal message={"Are you sure you want to Assign the Ticket?"} show={showAssignModal} onCloseClick={onCloseModalClick} onYesClick={onAssignTicket} />
        </div>
    );
};

export default KanbanList;